<mat-toolbar class="primary-toolbar" *ngIf="toolbarService.state()">
  <!-- Span for logo, product name, and version number -->
  <span class="left">
    <span style="height: 100%" [matTooltip]="versionNumber()">
      @if (customBase64Logo()) {
        <img style="height: 100%"
          class="product-logo"
          [src]="themeService.themeClass === 'custom-theme' ? customBase64Logo() : logoPath()"
          alt="Produktlogo"
        >
      } @else if (logoPath()) {
        <img
          style="height: 100%;"
          [src]="logoPath()"
          alt="Firmenlogo"
        >
      }
    </span>

    <div
      class="centered"
      style="padding: 0 10px"
    >
      <!-- Calendar Type selection -->
      <mat-button-toggle-group
        class="calendar-type-wrapper"
        [(value)]="toolbarService.state().calendarType"
        (change)="onCalenderTypeChange($event)"
      >
        <mat-button-toggle [value]="ECalenderType.classic">
          Kalender
        </mat-button-toggle>

        <mat-button-toggle [value]="ECalenderType.easy">
          Zeitbereiche
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="calendar-wrapper">
      <kpi4me-date-picker
        (configurationChange)="onEasyDatePickerChange($event)"
        *ngIf="toolbarService.state().calendarType === ECalenderType.easy; else classicCalender"
        [(configuration)]="toolbarService.state().easyDatePicker"
      ></kpi4me-date-picker>

      <ng-template #classicCalender>
        <kpi4me-calendar
          (dateChange)="onDateChange($event)"
          [config]="toolbarService.state().classicalCalendar"
          [selectedGranularity]="toolbarService.state().classicalCalendar.granularity"
          [lowestGranularity]="lowestGranularity"
          [showGranularityButtons]="true"
        ></kpi4me-calendar>
      </ng-template>
    </div>

    <div class="text-filter-form">
        <span style="margin-right: 0.5rem; margin-left: auto; display: flex; align-items: center">
             <mat-icon
               style="display: flex; justify-content: center"
               [svgIcon]="EsvgFiles.search"
               matPrefix
             ></mat-icon>
        </span>

        <span>
             <input
               [formControl]="textFilterControl"
               type="text"
               placeholder="Volltextfilter"
               name="textFilterForm"
               (focus)="onFocusFullTextFilter(textFilterControl.value)"
               (blur)="checkForFullTextFilterChanges(textFilterControl.value)"
               (keydown.enter)="checkForFullTextFilterChanges(textFilterControl.value)"
             >
        </span>

        <button style="display: flex;" class="unstyled-button centered" mat-ripple (click)="onClear()">
                    <mat-icon
                      [svgIcon]="EsvgFiles.close"
                      style="display: flex; justify-content: center; cursor: pointer;"
                      matSuffix>
                    </mat-icon>
        </button>
    </div>
  </span>

  <!-- Span for menu -->
  <span class="right">
    <span class="label-wrapper">
      <span class="product-label">
        {{ tenant$ | async }}
      </span>

      <span class="version-label" *ngIf="userMenu.user">
        {{ userMenu.user.firstname + ' ' + userMenu.user.lastname }}
      </span>
    </span>

    <button class="user-icon" color="primary"
            mat-icon-button
            [matMenuTriggerFor]="userMenu?.menuRef"
    >
      <mat-icon svgIcon="{{EsvgFiles.user}}"></mat-icon>
    </button>

    @if(showHelpIcons()) {
      <lib-help-icon (click)="showHelpForToolbar()"/>
    }
  </span>
</mat-toolbar>

<app-user-menu
  [showTenantMenu]="showTenantMenu()"
  [menuOptions]="menuOptions()"
  [helpUrl]="helpUrl()"
  [supportUrl]="supportUrl()"
  [helpView]="helpView()"
  [moduleFilters]="moduleFilters()"
  (optionTriggered)="optionTriggered.emit($event)"
  (logout)="logout.emit()"
  (applyTheme)="applyTheme.emit($event)"
  (onOpenHelp)="openHelp.emit($event)"
></app-user-menu>
